import { render, staticRenderFns } from "./evaluationall.vue?vue&type=template&id=bbc51cd2&scoped=true&"
import script from "./evaluationall.vue?vue&type=script&lang=js&"
export * from "./evaluationall.vue?vue&type=script&lang=js&"
import style0 from "./evaluationall.vue?vue&type=style&index=0&id=bbc51cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc51cd2",
  null
  
)

export default component.exports